import React from 'react';
import {
  titleUI,
  ssnOrVaFileNumberNoHintSchema,
  ssnOrVaFileNumberNoHintUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI({
      title: ({ formData }) =>
        formData?.claimantNotVeteran === false
          ? content['identification-title-veteran']
          : content['identification-title-claimant'],
    }),
    'ui:description': <p>{content['identification-description']}</p>,
    veteranSocialSecurityNumber: ssnOrVaFileNumberNoHintUI(),
  },
  schema: {
    type: 'object',
    required: ['veteranSocialSecurityNumber'],
    properties: {
      veteranSocialSecurityNumber: ssnOrVaFileNumberNoHintSchema,
    },
  },
};
